export default "__VITE_ASSET__01875fb3__"